import { MainVar } from "@/entity/MainVar";
import { General } from "./General";
import { DropDownItem } from "./DropDownItem";

class SelectOption {
    value: string;
    text: string;

    constructor(
        value?: string,
        text?: string, 
      ) {
        this.value = value;
        this.text = text; 
      }
}

export enum SOURCE {
    PK_PAESI = "PK_PAESI",
    PK_CONTENITORI_OGGETTO = "PK_CONTENITORI_OGGETTO",
    PK_CONTENITORI_ACCESSORIO = "PK_CONTENITORI_ACCESSORIO",
    PK_DESTINAZIONI  = "PK_DESTINAZIONI",
    PK_QUANTITA = "PK_QUANTITA",
    PK_CAPACITA = "PK_CAPACITA"
}

let PK_PAESI_LIST : Array<SelectOption>;
let PK_CONTENITORI_OGGETTO_LIST : Array<SelectOption>;
let PK_CONTENITORI_ACCESSORIO_LIST : Array<SelectOption>;
let PK_DESTINAZIONI_LIST : Array<SelectOption>;
let PK_QUANTITA_LIST : Array<SelectOption>;
let PK_CAPACITA_LIST : Array<SelectOption>;

let mainVar: MainVar;

export async function ForceAllDropDownList(){
    PK_PAESI_LIST = await General.GetDropdownList(SOURCE.PK_PAESI);
    PK_CONTENITORI_OGGETTO_LIST = await General.GetDropdownList(SOURCE.PK_CONTENITORI_OGGETTO);
    PK_CONTENITORI_ACCESSORIO_LIST = await General.GetDropdownList(SOURCE.PK_CONTENITORI_ACCESSORIO);
    PK_DESTINAZIONI_LIST = await General.GetDropdownList(SOURCE.PK_DESTINAZIONI);
    PK_QUANTITA_LIST = await General.GetDropdownList(SOURCE.PK_QUANTITA);
    PK_CAPACITA_LIST = await General.GetDropdownList(SOURCE.PK_CAPACITA);
}

export async function SyncPkDropdowns() {    
    let firstLoad: boolean = false;
    if(mainVar == null) {
        mainVar = new MainVar();
        await mainVar.GetAsync();
        firstLoad = true;
    }
    
    if(firstLoad) {
        await ForceAllDropDownList();
    } else {
        let previousMainVar = new MainVar();
        previousMainVar.dropDownListLastUpdate = mainVar.dropDownListLastUpdate;
        previousMainVar.translationsLastUpdate = mainVar.translationsLastUpdate;
        previousMainVar.lastEndpointCheck = mainVar.lastEndpointCheck;

        await mainVar.GetAsync();
        if(mainVar.IsRecent(previousMainVar)) {    
            await ForceAllDropDownList();
        }
    }
}

export async function GetDropDownListBySource(source:string): Promise<SelectOption[]> {
    let selectOptions: Array<SelectOption> = [];

    await SyncPkDropdowns();

    switch(source) {
        case SOURCE.PK_PAESI: {
            selectOptions = PK_PAESI_LIST;
            break;
        }
        case SOURCE.PK_CONTENITORI_OGGETTO: {
            selectOptions = PK_CONTENITORI_OGGETTO_LIST;
            break;
        }
        case SOURCE.PK_CONTENITORI_ACCESSORIO: {
            selectOptions = PK_CONTENITORI_ACCESSORIO_LIST;
            break;
        }
        case SOURCE.PK_DESTINAZIONI: {
            selectOptions = PK_DESTINAZIONI_LIST;
            break;
        }
        case SOURCE.PK_QUANTITA: {
            selectOptions = PK_QUANTITA_LIST;
            break;
        }
        case SOURCE.PK_CAPACITA: {
            selectOptions = PK_CAPACITA_LIST;
            break;
        }
    }

    return selectOptions;
}